/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import axios from 'axios';
import { EitherAsync } from 'purify-ts/EitherAsync';
import { buildUrl } from '@/utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function getTaskHistory(offset, limit) {
    const url = buildUrl('/api/v1/tasks/', { query: { offset, limit } });
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    const getData = () => axios.get(url).then(({ data }) => data);
    return EitherAsync(getData);
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function restartTask(taskId) {
    const url = buildUrl(['api', 'v1', 'tasks', taskId, 'restart']);
    return axios.post(url);
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function revokeTask(taskId) {
    const url = buildUrl(['api', 'v1', 'tasks', taskId, 'revoke']);
    return axios.post(url);
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export async function getTaskResult(taskId) {
    const url = buildUrl(['api', 'v1', 'tasks', taskId]);
    return await axios.get(url);
}
